import React, { useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import '../styles/WaitingRoom.css';
import fr from '../locales/fr';
import en from '../locales/en';
import normalImage1 from '../img/prop1.png';
import normalImage2 from '../img/prop2.png';
import normalImage3 from '../img/prop3.png';
import normalImage4 from '../img/prop4.png';
import normalImage5 from '../img/prop5.png';
import normalImage6 from '../img/prop6.png';
import normalImage7 from '../img/prop7.png';
import normalImage8 from '../img/prop8.png';
import normalImage9 from '../img/prop9.png';
import normalImage10 from '../img/prop10.png';
import normalImage11 from '../img/prop11.png';
import normalImage12 from '../img/prop12.png';
import normalImage13 from '../img/prop13.png';
import normalImage14 from '../img/prop14.png';
import normalImage15 from '../img/prop15.png';
import normalImage16 from '../img/prop16.png';
import normalImage17 from '../img/prop17.png';
import normalImage18 from '../img/prop18.png';
import spookyImage1 from '../img_spooky/halloween_prop1.png';
import spookyImage2 from '../img_spooky/halloween_prop2.png';
import spookyImage3 from '../img_spooky/halloween_prop3.png';
import spookyImage4 from '../img_spooky/halloween_prop4.png';
import spookyImage5 from '../img_spooky/halloween_prop5.png';
import spookyImage6 from '../img_spooky/halloween_prop6.png';
import spookyImage7 from '../img_spooky/halloween_prop7.png';
import spookyImage8 from '../img_spooky/halloween_prop8.png';
import spookyImage9 from '../img_spooky/halloween_prop9.png';
import spookyImage10 from '../img_spooky/halloween_prop10.png';
import spookyImage11 from '../img_spooky/halloween_prop11.png';
import spookyImage12 from '../img_spooky/halloween_prop12.png';
import spookyImage13 from '../img_spooky/halloween_prop13.png';
import spookyImage14 from '../img_spooky/halloween_prop14.png';
import spookyImage15 from '../img_spooky/halloween_prop15.png';

const isHalloween = new Date().getMonth() === 9;

function WaitingRoom({ ws }) {
  const navigate = useNavigate();
  const location = useLocation();
  const browserLang = navigator.language || navigator.userLanguage;
  const language = browserLang.startsWith('fr') ? 'fr' : 'en';
  const translations = language === 'fr' ? fr : en;

  const allowed =
    location.state?.fromAuthorized ||
    sessionStorage.getItem('canAccessWaitingState');


  useEffect(() => {
    const handleWebSocketMessage = (event) => {
      const message = event.data;
      const ROOM = localStorage.getItem('UNITY');

      switch (message) {
        case ROOM + ":START":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessOnTV', 'true');
          navigate("/onTV", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":ANSWER":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessAnswer', 'true');
          navigate("/answer", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":CLOSE":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessRestart', 'true');
          navigate("/restart", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":VOTE":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessExportVote', 'true');
          navigate("/exportVote", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":GO READY":
          ws.onmessage = null;
          sessionStorage.setItem('canAccessReady', 'true');
          navigate("/Ready", { state: { fromAuthorized: true } });
          break;
        default:
          console.log("Message non reconnu:", message);
      }
    };

    // WebSocket initialisation, assurez-vous que `ws` est correctement initialisé

    const generateImages = () => {
      const numberOfImages = 5;
      const container = document.querySelector('.container');
      if (!container) return;

      const images = isHalloween
        ? [spookyImage1, spookyImage2, spookyImage3, spookyImage4, spookyImage5,
           spookyImage6, spookyImage7, spookyImage8, spookyImage9, spookyImage10,
           spookyImage11, spookyImage12, spookyImage13, spookyImage14, spookyImage15]
        : [normalImage1, normalImage2, normalImage3, normalImage4, normalImage5,
           normalImage6, normalImage7, normalImage8, normalImage9, normalImage10,
           normalImage11, normalImage12, normalImage13, normalImage14, normalImage15,
           normalImage16, normalImage17, normalImage18];

      for (let i = 0; i < numberOfImages; i++) {
        const image = document.createElement('img');
        const randomImageIndex = Math.floor(Math.random() * images.length);
        const randomSize = Math.random() * 50 + 30;
        const randomX = Math.random() * (window.innerWidth - randomSize);
        const randomAnimationDuration = Math.random() * 5 + 2;

        image.setAttribute('src', images[randomImageIndex]);
        image.classList.add('rain-image');
        image.style.width = `${randomSize}px`;
        image.style.position = 'absolute';
        image.style.left = `${randomX}px`;
        image.style.top = `-${randomSize}px`;
        image.style.animationDuration = `${randomAnimationDuration}s`;
        image.style.transition = `top ${randomAnimationDuration}s linear`;

        container.appendChild(image);

        setTimeout(() => {
          image.style.top = `${window.innerHeight}px`;
        }, 0);
      }
      container.addEventListener('transitionend', handleTransitionEnd);
    };

    const handleTransitionEnd = (event) => {
      const container = document.querySelector('.container');
      const image = event.target;

      if (container.contains(image)) {
        container.removeChild(image);
      }
    };

    // Mettre en place l'écouteur d'événements WebSocket
    ws.onmessage = handleWebSocketMessage;

    generateImages();
    const interval = setInterval(generateImages, 2500);
    return () => {
      clearInterval(interval);
      // Nettoyer l'écouteur d'événements WebSocket lors du démontage du composant
      ws.onmessage = null;
    };
  }, [ws, navigate]); // Ajouter navigate comme dépendance

  useEffect(() => {
    if (allowed) {
      sessionStorage.removeItem('canAccessWaitingState');
    }
  }, [allowed]);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container">
      <h1 className="title">{translations.waitingState.title}<span className="dots"></span></h1>
      <div className="loader"></div>
    </div>
  );
}

export default WaitingRoom;
